import React from "react"

interface Props {
  color?: string
  opacity?: number
}
export default function SmallCheckIcon({ color = "black", opacity = 0.3 }: Props) {
  return (
    <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5212 0.521107C10.727 0.316123 11.0047 0.200759 11.2944 0.199955C11.5841 0.199152 11.8625 0.312974 12.0693 0.516814C12.2762 0.720653 12.3949 0.998132 12.3999 1.28926C12.4048 1.58039 12.2955 1.86177 12.0957 2.07258L6.22707 9.44576C6.12621 9.55495 6.00448 9.64258 5.86915 9.70341C5.73382 9.76423 5.58768 9.797 5.43947 9.79976C5.29125 9.80252 5.14401 9.77521 5.00653 9.71946C4.86906 9.66372 4.74418 9.58068 4.63936 9.47532L0.75095 5.56561C0.642623 5.46415 0.555737 5.34181 0.495474 5.20587C0.435212 5.06993 0.402808 4.92319 0.400196 4.77439C0.397584 4.62559 0.424817 4.47779 0.480271 4.3398C0.535725 4.20181 0.618263 4.07646 0.722962 3.97123C0.82766 3.866 0.952374 3.78304 1.08966 3.7273C1.22695 3.67156 1.37401 3.64419 1.52205 3.64682C1.67009 3.64944 1.81609 3.68201 1.95134 3.74258C2.08659 3.80315 2.20832 3.89048 2.30926 3.99936L5.38765 7.09196L10.4933 0.553614C10.5024 0.542168 10.5122 0.53131 10.5227 0.521107H10.5212Z"
        fill={color}
        fillOpacity={opacity}
      />
    </svg>
  )
}
